<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentcolor">
    <path
      d="M15.6 6.79059L14.1 10.1259L10.67 3L2 21H9.2H11.94C12.85 20.6824 15.14 18.6282 12.85 15.7906C11.49 14.0965 12.15 12.0529 13.52 11.1C12.95 11.7565 12.35 12.9635 13.17 14.5518C14.19 16.5318 18.96 15.5471 16.92 21H19.33H22L15.6 6.79059Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
